export const S3_URI_PREFIX = "s3://";
